export interface AttributeListRowModel {
  id: string;
  __fid?: string;
  attributes: Record<string, any>;
}
